import React from 'react';
import {Control, FieldValues, Path, UseFormRegister} from 'react-hook-form';
import {t} from '@lingui/core/macro';

import InputText from 'shared/ui/Input/InputText';

import styles from './RangeInputs.module.scss';

interface IRangeInputsProps<T extends FieldValues> {
    register: UseFormRegister<T>,
    control: Control<T>,
    fromName: Path<T>,
    toName: Path<T>,
}

function RangeInputs<T extends FieldValues>({register, control, fromName, toName}: IRangeInputsProps<T>) {
    return (
        <div className={styles.range}>
            <InputText register={register} control={control} name={fromName} placeholder={t`от`}/>
            <InputText register={register} control={control} name={toName} placeholder={t`до`}/>
        </div>
    );
}

export default RangeInputs;
